import { Carousel } from "@fancyapps/ui/dist/carousel/carousel.js";
import { Arrows } from "@fancyapps/ui/dist/carousel/carousel.arrows.js";
import { Dots } from "@fancyapps/ui/dist/carousel/carousel.dots.js";

export const initTestimonialsCarousel = () =>
{
    if (document.body.classList.contains('pdf-mode'))
    {
        return;
    }

    document.querySelectorAll('[data-type="testimonials"] .f-carousel').forEach(el =>
    {
        Carousel(el, { adaptiveHeight: true }, { Arrows, Dots }).init();
    });
};